/**
 * Poll messages and notifications
 */

import config from 'config';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import NotificationService from 'services/notification.service';
import { UserType } from 'types/user.types';
import { consoleError } from 'utils/log';

const pollInterval = config.get('messaging.pollInterval');
const notificationService = new NotificationService();

type Props = {
  user: UserType;
};

const mapStateToProps = ({ userData }) => ({
  user: userData && userData.user,
});

let poll;

const PollMessages = (props: Props) => {
  const { user } = props;

  async function fetchUnreadCounts() {
    try {
      notificationService.checkForNewNotifications({ silentFail: true });
    } catch (err) {
      consoleError('Fetching messages failed', err);
    }
  }

  function pollMessages(interval: number) {
    if (!interval) {
      throw new Error('No interval for message polling');
    }

    // Poll the unread all endpoint every set ms
    // for every failure, the poll interval is twice as long with maximum of 20 times the original limit.
    return setInterval(() => {
      try {
        fetchUnreadCounts();

        // on a successful call, reset the interval to whatever is set in configuration
        interval = pollInterval;
      } catch (e) {
        console.error(e);
        // for the first request the poll interval is 0, so if that request fails, set it here
        if (!pollInterval) {
          interval = pollInterval;
        }

        if (interval < pollInterval * 20) {
          interval *= 2;
        }
      }
    }, interval);
  }

  useEffect(() => {
    if (user.isLoggedIn) {
      fetchUnreadCounts(); // Fetch first time immediately
      poll = pollMessages(pollInterval);
    } else {
      clearInterval(poll);
    }
  }, [user]);

  return null;
};

export default connect(mapStateToProps)(PollMessages);
